// Permiso.js

import { useAuth } from "../context/AuthContext";

const Permiso = ({ permiso, children }) => {
    const { usuario } = useAuth();

  if (!usuario?.permisos?.includes(permiso)) return null;

  return children;
};

export default Permiso;